<template>
    <footer class="bg-teal-800 text-white py-8">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <!-- Company Info Section -->
          <div class="flex flex-col">
            <h3 class="text-lg font-bold mb-3">{{ $t('footer.company') }}</h3>
            <div class="text-gray-200 space-y-2 text-sm">
              <p>
                <span class="font-semibold text-white">{{ $t('footer.legalSeat') }}:</span><br />
                Via San Lorenzo Guazzone, 19<br />
                26030 Tornata (CR)
              </p>
              <p>
                <span class="font-semibold text-white">{{ $t('footer.operationalSeat') }}:</span><br />
                Via Casa Bianca, 19<br />
                26037 San Giovanni in Croce (CR)
              </p>
              <p>
                <span class="font-semibold text-white">{{ $t('footer.phone') }}:</span><br />
                +39 339 500 9989<br />
                +39 335 722 2343
              </p>
              <p>
                <span class="font-semibold text-white">{{ $t('footer.email') }}:</span><br />
                info@pizzoni.net<br />
              </p>
            </div>
          </div>
  
          <!-- Navigation Links Section -->
          <div class="flex flex-col">
            <h3 class="text-lg font-bold mb-2">{{ $t('footer.quickLinks') }}</h3>
            <ul class="space-y-2">
              <li><a href="#home" @click.prevent="scrollTo('home')" class="hover:underline text-gray-200 hover:text-white transition-colors">{{ $t('nav.home') }}</a></li>
              <li><a href="#about" @click.prevent="scrollTo('about')" class="hover:underline text-gray-200 hover:text-white transition-colors">{{ $t('nav.about') }}</a></li>
              <li><a href="#offers" @click.prevent="scrollTo('offers')" class="hover:underline text-gray-200 hover:text-white transition-colors">{{ $t('nav.offers') }}</a></li>
              <li><a href="#contact" @click.prevent="scrollTo('contact')" class="hover:underline text-gray-200 hover:text-white transition-colors">{{ $t('nav.contact') }}</a></li>
            </ul>
          </div>
  
          <!-- Social Media Section -->
          <div class="flex flex-col">
            <h3 class="text-lg font-bold mb-2">{{ $t('footer.followUs') }}</h3>
            <div class="flex space-x-4">
              <a href="https://www.instagram.com/pizzoniviaggi_official/" target="_blank" class="bg-white/10 p-2 rounded-full hover:bg-white/20 transition-colors">
                <img class="h-6 w-6" src="https://cdn4.iconfinder.com/data/icons/picons-social/57/38-instagram-2-512.png" alt="Instagram">
              </a>
              <a href="https://www.facebook.com/pizzoni.official/?locale=it_IT" target="_blank" class="bg-white/10 p-2 rounded-full hover:bg-white/20 transition-colors">
                <img class="h-6 w-6" src="https://static.vecteezy.com/system/resources/thumbnails/018/930/481/small_2x/facebook-logo-facebook-icon-transparent-free-png.png" alt="Facebook">
              </a>
            </div>
          </div>
        </div>
        <div class="mt-8 pt-6 border-t border-white/20 text-center text-sm text-gray-300">
          © {{ currentYear }} Pizzoni Viaggi. {{ $t('footer.rights') }}.
        </div>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'FooterComponent',
    data() {
      return {
        currentYear: new Date().getFullYear()
      };
    },
    methods: {
      scrollTo(sectionId) {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* Add any additional styles here if needed */
  </style>
  